import React, { useState } from 'react';
import { useParams } from 'react-router-dom';

function formatDate(dateStr) {
  return new Date(dateStr + 'T00:00:00').toLocaleDateString('de-DE', {
    weekday: 'long',
    day: '2-digit',
    month: 'long',
    year: 'numeric'
  });
}

function KursinhaltZugang() {
  const { courseId } = useParams();
  const [name, setName] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [result, setResult] = useState(null);

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);

    fetch(`/api/kursinhalt/${courseId}/access`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ name, password })
    })
      .then(async (res) => {
        const data = await res.json();
        if (!res.ok) throw new Error(data.error || 'Zugriff nicht moeglich');
        setResult(data.data);
      })
      .catch((err) => setError(err.message))
      .finally(() => setLoading(false));
  };

  if (result) {
    return (
      <div className="row justify-content-center">
        <div className="col-12 col-lg-10">
          <h4 className="mb-4">Kursinhalte: {result.course_name}</h4>
          {result.entries.length === 0 ? (
            <div className="alert alert-info">Für diesen Kurs wurden noch keine Inhalte hinterlegt.</div>
          ) : (
            result.entries.map((entry) => (
              <div
                key={entry.occurrence_date}
                className={`card mb-3 ${entry.is_today ? 'border-primary' : ''}`}
              >
                <div className={`card-header ${entry.is_today ? 'bg-primary text-white' : ''}`}>
                  {formatDate(entry.occurrence_date)}
                  {entry.is_today && <span className="badge bg-light text-primary ms-2">Heute</span>}
                </div>
                <div className="card-body">
                  {entry.title && <h5 className="card-title">{entry.title}</h5>}
                  {entry.description && <p className="card-text">{entry.description}</p>}
                  {entry.materials && (
                    <p className="mb-1"><strong>Material:</strong> {entry.materials}</p>
                  )}
                  {entry.presentation_url && (
                    <p className="mb-0">
                      <a href={entry.presentation_url} target="_blank" rel="noopener noreferrer">
                        Präsentation öffnen
                      </a>
                    </p>
                  )}
                </div>
                {entry.content_html && (
                  <iframe
                    srcDoc={entry.content_html}
                    title={`Inhalt ${entry.occurrence_date}`}
                    style={{ width: '100%', height: '85vh', border: 'none', borderTop: '1px solid #dee2e6' }}
                  />
                )}
              </div>
            ))
          )}
        </div>
      </div>
    );
  }

  return (
    <div className="row justify-content-center">
      <div className="col-md-5">
        <div className="card">
          <div className="card-header">
            <h5 className="mb-0">Kursinhalte ansehen</h5>
          </div>
          <div className="card-body">
            <p className="text-muted small mb-4">
              Gib deinen Vornamen und das Kurs-Passwort ein, um die Inhalte für diesen Kurs zu sehen.
            </p>
            {error && <div className="alert alert-danger">{error}</div>}
            <form onSubmit={handleSubmit}>
              <div className="mb-3">
                <label className="form-label">Dein Vorname</label>
                <input
                  type="text"
                  className="form-control"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  required
                />
              </div>
              <div className="mb-3">
                <label className="form-label">Kurs-Passwort</label>
                <input
                  type="password"
                  className="form-control"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                />
              </div>
              <button type="submit" className="btn btn-primary w-100" disabled={loading}>
                {loading ? 'Prüfe...' : 'Inhalte ansehen'}
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}

export default KursinhaltZugang;
